import { getScores } from '../../util/reducer-helpers';
import {
    CONFIRM_ROSTER_PLAYER,
    CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED,
    CONFIRMING_ROSTER_PLAYERS_SUCCEEDED,
    DISMISS_GAME_REPORT_REFEREE_CHANGES,
    LOADING_SCORES_SUCCEEDED,
    LOGOUT_FAILED,
    LOGOUT_SUCCEEDED,
    SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED,
    SIGNING_GAME_REPORT_REFEREE_SUCCEEDED,
    UPDATE_GAME_REPORT_REFEREE
} from '../constants/actionTypes';

const initialState = {
    rosters:            {},
    gameReportsReferee: {}
};

const reducer = ( state = initialState, action ) => {

    // console.log( 'reducers.localChanges', state, action );

    switch ( action.type ) {

        case CONFIRM_ROSTER_PLAYER: {

            const { gameId, playerId, isConfirmed } = action.payload;
            const rosters                           = { ...state.rosters };

            if ( ! ( gameId in rosters ) ) {

                rosters[ gameId ]             = {};
                rosters[ gameId ][ playerId ] = { isConfirmed };

            } else if ( ! ( playerId in rosters[ gameId ] ) ) {

                rosters[ gameId ][ playerId ] = { isConfirmed };

            } else if ( 'isConfirmed' in rosters[ gameId ][ playerId ] ) {

                delete rosters[ gameId ][ playerId ].isConfirmed;

            } else  {

                rosters[ gameId ][ playerId ].isConfirmed = isConfirmed;

            }

            return { ...state, rosters };

        }

        case CONFIRMING_ROSTER_PLAYERS_SUCCEEDED: {

            const { gameId } = action.payload;
            const rosters    = { ...state.rosters };

            if ( gameId in rosters ) {

                for ( const playerId in rosters[ gameId ] ) {

                    delete rosters[ gameId ][ playerId ].isConfirmed;

                }

            }

            return { ...state, rosters };

        }

        case LOADING_SCORES_SUCCEEDED: {

            const { gameId, scores } = action.payload;
            const gameReportsReferee = { ...state.gameReportsReferee };
            const gameReportReferee  = ( gameId in gameReportsReferee ) ? { ...gameReportsReferee[ gameId ] } : {};

            gameReportReferee.periodScoresHome = getScores( gameReportReferee.periodScoresHome || [], scores.home );
            gameReportReferee.periodScoresAway = getScores( gameReportReferee.periodScoresAway || [], scores.away );

            gameReportsReferee[ gameId ] = gameReportReferee;

            return { ...state, gameReportsReferee };

        }

        case LOGOUT_FAILED:
        case LOGOUT_SUCCEEDED: {

            return initialState;

        }

        case CONFIRMING_GAME_REPORT_REFEREE_SUCCEEDED:
        case DISMISS_GAME_REPORT_REFEREE_CHANGES:
        case SAVING_GAME_REPORT_REFEREE_DRAFT_SUCCEEDED:
        case SIGNING_GAME_REPORT_REFEREE_SUCCEEDED:

        {

            const { gameId }         = action.payload;
            const gameReportsReferee = { ...state.gameReportsReferee };

            delete gameReportsReferee[ gameId ];

            return { ...state, gameReportsReferee };

        }

        case UPDATE_GAME_REPORT_REFEREE: {

            const { gameId, data }   = action.payload;
            const gameReportsReferee = { ...state.gameReportsReferee };

            gameReportsReferee[ gameId ] = { ...gameReportsReferee[ gameId ], ...data };

            return { ...state, gameReportsReferee };

        }

        default:

            return state;

    }

};

export default reducer;